module.exports = __webpack_public_path__ + "images/psp/DriveUpIcons/DriveUpSizeChartOne/iconTwo.svg";